const getModuleState = (state) => state.headers;

export const getAllHeaders = (state) => getModuleState(state).allHeaders;
export const getHeaderBySlug = (state) => getModuleState(state).headerBySlug;